var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"window"},[_c('Cover',{attrs:{"index":"2","visible":true}}),(_vm.validComponent())?_c('div',{staticClass:"windowContent"},[_c('CloseButton'),_c(_vm.window,{tag:"div",attrs:{"param":_vm.param}})],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }